import { darken } from '@mui/material';
import { styled } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';

const CustomDataGrid = styled(DataGrid)(({ theme }) => ({
  overflowY: 'scroll',
  overflowX: 'auto',
  width: '100%',
  cursor: 'pointer',
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '3px',
    margin: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.divider,
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
    borderRadius: '3px',
  },
  '& .MuiDataGrid-virtualScroller': {
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent',
      borderRadius: '3px',
      margin: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.divider,
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: `${darken(theme.palette.divider, 0.16)}`,
      borderRadius: '3px',
    },
  },
}));

const DataTable = ({
  rows,
  columns,
  pageSize,
  rowsPerPageOptions,
  headerHeight,
  rowHeight,
  onRowClick,
  height,
}) => {
  return (
    <CustomDataGrid
      {...{
        rows,
        columns,
        pageSize,
        rowsPerPageOptions,
        headerHeight,
        rowHeight,
        onRowClick,
        style: { height },
      }}
    />
  );
};

export default DataTable;
